import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Result, Button, Spin } from 'antd';
import { StyledLayout, StyledSider, StyledContent } from './styles/AdminStyles';
import AdminMenu from './AdminMenu';
import { getLoginUser } from '../../api/user';

const AdminLayout = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [username, setUsername] = useState<string>('');

    useEffect(() => {
        const checkAdminPermission = async () => {
            try {
                const userData = await getLoginUser();

                // ADMIN 권한 체크
                if (userData?.role === 'ADMIN_MAIN'
                    // || userData?.role === "ADMIN_SUB" // 추후 확장 필요하면 추가
                ) {
                    setIsAdmin(true);
                } else {
                    setIsAdmin(false);
                }
                setUsername(userData?.username ?? '');
            } catch (error) {
                console.error('Failed to fetch user data:', error);
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };

        checkAdminPermission();
    }, []);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px', flexDirection: 'column', gap: '16px' }}>
                <Spin size="large" />
                <span>권한 확인 중...</span>
            </div>
        );
    }

    if (!isAdmin) {
        return (
            <Result
                status="403"
                title="접근 권한이 없습니다"
                subTitle="관리자 권한이 필요한 페이지입니다."
                extra={
                    <Button type="primary" onClick={() => navigate('/')}>
                        홈으로 돌아가기
                    </Button>
                }
            />
        );
    }

    return (
        <StyledLayout>
            <StyledSider width={210} theme="light">
                <AdminMenu username={username} />
            </StyledSider>
            <StyledContent>
                <Outlet />
            </StyledContent>
        </StyledLayout>
    );
};

export default AdminLayout;
